import { useState } from 'react';

import type { SectionData } from '@/app/[locale]/how-it-works/_data/timelineSections';
import Motion from '@/app/components/Motion';

import AppUIWrapper from './AppUIWrapper';
import Section from './Section';
import SectionSpacerTrack from './SectionSpacerTrack';
import StickyTimeline from './StickyTimeline';

export interface TimelineProps {
  readonly sections: SectionData[];
}

const Timeline = ({ sections }: TimelineProps) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [previousIndex, setPreviousIndex] = useState<number>(0);
  const handleActiveSectionChange = (index: number) => {
    setPreviousIndex(activeIndex);
    setActiveIndex(index);
  };
  const sectionCount = sections.length;

  return (
    <Motion
      initial={{
        opacity: 0,
      }}
      className="relative overflow-y-clip"
      data-cy="timeline"
      transition={{
        duration: 2,
        type: 'tween',
      }}
      viewport={{
        once: true,
      }}
      whileInView={{
        opacity: 1,
      }}
    >
      {sections.map((section, i) => (
        <Section
          {...section}
          activeIndex={activeIndex}
          index={i}
          key={section.id}
          previousIndex={previousIndex}
          sectionCount={sectionCount}
        />
      ))}
      <SectionSpacerTrack
        activeIndex={activeIndex}
        onActiveSectionChange={handleActiveSectionChange}
        sectionCount={sectionCount}
      />
      <AppUIWrapper
        activeIndex={activeIndex}
        previousIndex={previousIndex}
        sections={sections}
      />
      <StickyTimeline activeIndex={activeIndex} sections={sections} />
    </Motion>
  );
};

export default Timeline;
